"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// import PropTypes from 'prop-types';
// Styles
require("./Credits.css");
function Credits(props) {
    // props
    var debug = props.debug, children = props.children;
    // if(!!debug) console.log('children',children);
    if (!!children)
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "credits" }, { children: children }), void 0));
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "credits" }, { children: ["Icons made by ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.flaticon.com/authors/freepik", title: "Freepik" }, { children: "Freepik" }), void 0), " from ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.flaticon.com/", title: "Flaticon" }, { children: " www.flaticon.com" }), void 0)] }), void 0));
}
exports.default = Credits;
//# sourceMappingURL=Credits.js.map